<template>
    <!-- PC各地mm群 -->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>
    <div class="container errong">
        <div class="container-fluid mt-2">
            <!--二个按钮-->
            <ZhaiTwoTuttonsPC></ZhaiTwoTuttonsPC>
            <!--二个按钮-->
            <div class="row shengse">
                <div class="dixian px-3 py-2 d-flex justify-content-between">
                    <div class="lf"><i class="bi bi-cup"></i>精品入驻推荐</div>
                </div>
            </div>
        </div>

        <!-- 卡片区域 -->
        <div class="row card-container mt-2">
            <div class="col-md-4 mb-1" v-for="item in posts" :key="item.id">
                <a @click.prevent="handleCardClick(item)" class="card-link">
                    <div class="card h-100">
                        <div class="row g-0 h-100">
                            <div class="col-4 p-0 d-flex align-items-center justify-content-center">
                                <div class="image-container">
                                    <img :src="item.img" alt="..." class="card-img">
                                </div>
                            </div>
                            <div class="col-8 d-flex flex-column h-100">
                                <div class="card-body p-1 d-flex flex-column h-100">
                                    <div class="header flex-shrink-0">
                                        <h5 class="card-title mt-3">{{ item.name }}</h5>
                                        <div class="ri mb-1 mt-2">
                                            <i class="bi bi-clock riqiziti">
                                                <span>&nbsp;{{ item.createTime.substr(0, 10) }}&nbsp;&nbsp;</span>
                                            </i>
                                            <i class="bi bi-star-fill riqiziti">
                                                <span>&nbsp;{{ item.collectCount }}收藏</span>
                                            </i>
                                        </div>
                                    </div>
                                    <div class="content flex-grow-1">
                                        <p class="card-text">{{ item.history }}</p>
                                    </div>
                                    <div class="footer mb-2 flex-shrink-0">
                                            <span class="bi bi-send-fill weiz changlv">
                                                &nbsp;{{ item.province }}-{{ item.city }}
                                            </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div class="bg-white my-2 p-3 G-Field text-center d-flex justify-content-center align-items-center">
            <a class="page-link pagination-btn" href="#" aria-label="Previous" @click.prevent="prevPage"
               :disabled="currentPage === 1">
                <span aria-hidden="true">«</span>
            </a>
            <span style="margin: 0 1rem;">第 {{ currentPage }} 页，共 {{ totalPages }} 页</span>
            <a class="page-link pagination-btn" href="#" aria-label="Next" @click.prevent="nextPage"
               :disabled="currentPage === totalPages">
                <span aria-hidden="true">»</span>
            </a>
        </div>

    </div>

    <ZhaiFootPC></ZhaiFootPC>
</template>


<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiTwoTuttonsPC from "../componentspc/ZhaiTwoTuttonsPC";
    import http from "../utils/http.js";

    export default {
        name: "PRegionalGroups",
        components: { ZhaiHeadPC, ZhaiFootPC, ZhaiTwoTuttonsPC },
        data() {
            return {
                posts: [], // 存储获取到的数据
                pageNum: 1, // 当前页码
                pageSize: 24, // 每页显示条数
                totalPages: 1 // 总页数
            };
        },
        mounted() {
            this.fetchPosts();
        },
        methods: {
            fetchPosts() { const url = `/platform/frontEnd/recommendSpecial?pageNum=${this.pageNum}&pageSize=${this.pageSize}`;
                http.get(url)
                    .then((response) => {
                        if (response.data && response.data.status === 1) {
                            this.posts = response.data.data.list;
                            this.totalPages = Math.ceil(response.data.data.total / this.pageSize);
                        } else {
                            console.error("获取推荐数据失败:", response.data.msg);
                        }
                    })
                    .catch((error) => {
                        console.error("API 请求错误:", error);
                    });
            },
            // 上一页
            prevPage() {
                if (this.pageNum > 1) {
                    this.pageNum--;
                    this.fetchPosts();
                }
            },
            // 下一页
            nextPage() {
                if (this.pageNum < this.totalPages) {
                    this.pageNum++;
                    this.fetchPosts();
                }
            },
            handleCardClick(post) {
                // 跳转到详情页面
                this.$router.push({
                    name: "detailPage2",
                    query: { id: post.id },
                });
            }
        }
    };
</script>


<style scoped>
    .bi {
        margin-right: 2px; /* 图标和文字之间的间距 */
    }
    .card {
        text-decoration: none;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        border: none;
        cursor: pointer !important;
    }
    .col-4 {
        width: 115px;
        height: 155px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        padding: 0;
    }
    .image-container {
        width: 99px;
        height: 132px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 4px;
    }
    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .col-8 {
        max-height: 155px;
    }
    .card-body {
        display: flex;
        flex-direction: column;
        padding: 0.1rem;
        height: 100%;
    }
    .card-title {
        font-size: 1rem;
    }
    .card-text {
        margin-bottom: 0.5rem !important;
        font-size: 0.9rem !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .ri {
        display: flex;
        align-items: center;
        font-size: 0.8rem;
    }
    .riqiziti {
        font-style: normal;
        font-size: 0.8rem;
        margin-right: 4px;
    }
    .ri i + i {
        margin-left: 4px;
    }
    .changlv {
        color: #18b371 !important;
    }
    .content {
        display: flex;
        flex-direction: column;
        margin-top: 0.2rem;
    }
    .card-link {
        text-decoration: none;
        color: inherit;
    }
    .weiz {
        font-size: 0.9rem;
    }

    /*升级帮助里面的问题*/
    .uphelp h1, p {
        font-size: 0.7rem;
    }



    /* 增加模态框中两个按钮的间距 */
    .modal-body .btn {
        margin-right: 60px; /* 调整为合适的数值 */
    }

    .modal-body .btn:last-child {
        margin-right: 0; /* 确保最后一个按钮没有多余的右边距 */
    }
    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .errong {
            margin-top: 90px; /* 根据导航栏高度调整 */
        }
    }



</style>
